import { Button, Card, Col, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";

const ExpenseRequestFilter = ({
    handleSearchFilter = () => { },
    dropdownWelfareSubTypeByCode = []
}) => {
    const { t } = useTranslation();

    return (
        <FormAntd
            onFinish={handleSearchFilter}
        >
            <FormItem shouldUpdate={(prev, curv) => {
                return false
            }}>
                {({ getFieldValue, setFieldValue, resetFields }) => {
                    return (
                        <Space direction="vertical" size={24} style={{ width: "100%" }}>
                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                <Col span={8}>
                                    <FormInput
                                        name="sequence"
                                        label={t("expense.expense-detail.request-id")}
                                        // placeholder={t("payroll.label.welfarenameorcode")}
                                        size="large"
                                        allowClear
                                    />
                                </Col>

                                <Col span={8}>
                                    <FormSelect
                                        name="welfareSubCategoryType"
                                        label={t('expense.header')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        allowClear
                                        options={dropdownWelfareSubTypeByCode}
                                    />
                                </Col>
                                <Col span={8}>
                                    <FormSelect
                                        name="approveStatusEn"
                                        label={t('translation.status')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={[
                                            { value: 'Draft', label: t("approve-status.draft") },
                                            { value: 'Pending', label: t("approve-status.pending") },
                                            { value: 'Approved', label: t("approve-status.approve") },
                                            { value: 'Rejected', label: t("approve-status.reject") },
                                        ]}
                                        allowClear
                                    />
                                </Col>
                            </Row>
                            <Row gutter={24} style={{ gap: "16px" }} justify={"end"}>
                                <Space size={16}>
                                    <Button type="default" onClick={() => resetFields()} size="large">
                                        {t('payroll.reset')}
                                    </Button>
                                    <Button type="primary" htmlType="submit" size="large" style={{ backgroundColor: "var(--button-color)" }}>
                                        {t("creatTamplete.Search").toUpperCase()}
                                    </Button>
                                </Space>
                            </Row>
                        </Space>
                    )
                }}
            </FormItem>
        </FormAntd>
    )
}

export default ExpenseRequestFilter;